<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-2"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">
      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1"
                  @click="getDataForTable()"
                  icon="refresh"
                  tooltip="Ansicht aktualisieren"
                  label="Aktualisieren"
                  hide-label></lx-btn>
          <lx-btn small classes="mr-1"
                  @click="addTabToStore({routeName: 'PhysicianNew', options: {icon: 'mdi-new-box', headline: 'Arzt'}})"
                  icon="mdi-account-plus"
                  tooltip="Neuen Arzt anlegen"
                  label="Arzt anlegen"
                  hide-label></lx-btn>
        </div>

        <div class="flex layout-row mr-1">
          <lx-search-field
            placeholder="Suchbegriff (Nachname, Vorname, Loginname, Email)"
            dense
            v-model="tableObj.filterValue"
            :data-method="getDataForTable"
          ></lx-search-field>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">
        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;" :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <lx-data-table
              tableName="PhysiciansList"
              v-model="tableObj.selection"
              :items="physiciansItems"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :tableOptions="tableObj.options"
              :hideContextFilter="true"
              @changeOptions="changeTableOptions"
              @rowClicked="openPhysicianDetails"
              :no-data-text="$t('AG_GRID.NO_ROWS')"
              hide-default-footer
            >

              <template v-slot:cellrenderer="{ value }">
                <div v-if="value.f.renderer === 'checkbox'" style="height:35px;" class="layout-column layout-align-center-center">
                  <v-simple-checkbox :dark="compColor.isInDarkMode"
                                     :color="compColor.primeColor"
                                     disabled
                                     v-model="value.i.is_active"></v-simple-checkbox>
                </div>

                <div v-if="value.f.renderer === 'resend'" style="height:35px;" class="layout-column layout-align-center-start">
                  <div v-if="value.i.pending && !value.i.waitForFirstLogin" @click="resendInvitation($event, value.i)" class="layout-row layout-align-center-center">
                    <v-icon class="mr-1" :color="compColor.primeColor" style="font-size: 17px;">mdi-email-send-outline</v-icon> <label  style="cursor: pointer;">{{ $t('PHYSICIANS_LIST.TABLE.RESEND') }}</label>
                  </div>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'PhysiciansList'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable"></lx-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import LxPagination from "../../../components/lx_pagination/LxPagination"
import utils from "../../../common/utils"

export default {
  name: 'PhysiciansList',
  mixins: [utils],
  data () {
    return {
      rowHeight: 35,
      physiciansItems: [],
      itemsTotalCount: 0,
      tableHeight: 150,
      isLoadingData: false,
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      tableObj: {
        loading: false, // benutzt während des GetDatas, um eine Ladeanimation einzublenden
        options: {
          sortBy: ['lastname'],
          sortDesc: [false],
        },
        selection: null,
        filterValue: null,
        headers: [
          {
            text: this.$t('COMPONENT_ACCOUNT.LASTNAME'),
            value: 'lastname',
            sortable: true,
            width: '200px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.FIRSTNAME'),
            value: 'firstname',
            sortable: true,
            width: '200px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.EMAIL'),
            value: 'email',
            width: '150px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.LANR'),
            value: 'lanr',
            width: '150px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.IKNR'),
            value: 'iknr',
            width: '150px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.IS_ACTIVE'),
            value: 'is_active',
            class: 'text-center',
            width: '100px',
            renderer: 'checkbox'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.LOGIN'),
            value: 'login_name',
            width: '200px'
          },
          {
            text: '',
            value: '',
            renderer: 'resend'
          }
        ]
      }
    }
  },
  components: {
    LxPagination
  },
  created () {
    this.getDataForTable()
  },
  methods: {
    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * Methode wird vom Grid angesprungen, wenn man doppelt auf eine Zeile klickt. Dann wird die Detailansicht geöffent.
     * Kann auch an einen Editbutton in einer Spalte gehangen werden aber Doppelklick ist komfortabler.
     * **/
    openPhysicianDetails (params) {
      if (params && params.id) {
        this.addTabToStore({
          routeName: 'PhysicianDetails',
          routeParams: { physicianId: params.id },
          options: {
            headline: params.lastname && params.firstname ? params.lastname + ', ' + params.firstname : params.email
          }
        })
      }
    },

    /**
     * Wird verschiedenen Stellen aus aufgerufen und soll die Daten vom Backend abholen. Mittels axios....bla bla bla
     * Besonderheit:
     * "this.pagingOptions.count = res.data.count"
     * - Anzahl der Datensätze vom Server wird auch in den pagingOptions gespeichert
     *
     * "this.$store.dispatch('setPagingOptions', this.pagingOptions)"
     * - nach der Speicherung der Anzahl werden die pagingOptions wieder in den Store geschrieben
     *
     * "this.gridOptions.api.ensureIndexVisible(this.$store.getters.gridScrollIndex, 'top')"
     * - sorgt dafür das nach dem Neuladen der Daten das Grid wieder an die Stelle scrollt wo es war. notwendig z.B. bei der Rückkehr zum Grid
     * **/
    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      // set search value only if filter value has content, else clear filter value (e.g. string has only spaces)
      if (this.tableObj.filterValue && this.tableObj.filterValue.replace(/\s/g, '').length > 0) {
        query['$searching'] = this.clearStringForRegexSearch(this.tableObj.filterValue)
      } else {
        this.tableObj.filterValue = null
      }

      this.$http.get('/role/physician?config={"opts":' + JSON.stringify(opts) + ', "query": ' + JSON.stringify(query) + '}')
        .then(res => {
          if (res.data) {
            this.physiciansItems = res.data.result || []

            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    /**
     * Trigger resend invitation Mail to physician
     */
    resendInvitation (event, params) {
      if (params && params.id) {
        if (this.tableObj.loading || this.isLoadingData) return
        this.isLoadingData = true

        this.$http.put('/physicians/resendInvitation/' + params.id)
          .then(() => {
            this.NotifySystem(this.$t('PHYSICIANS_LIST.NOTIFICATIONS.RESEND.SUCCESS'))
          })
          .catch(() => {
            this.NotifyError(this.$t('PHYSICIANS_LIST.NOTIFICATIONS.RESEND.ERROR'))
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
      event.stopPropagation()
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'PhysiciansList') {
        this.getDataForTable()
      }
    }
  }
}
</script>
<!-- Add 'scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 35px;
}

.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > th {
  height: 40px;
  font-size: 13px;
}

.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
  z-index: 2;
}

tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
